import React from 'react';
import { trackCustom } from '../lib/pixel';
const trackOutbound = (target: string) => trackCustom('OutboundClick', {
  target
});
export function Footer() {
  return <footer className="w-full px-4 sm:px-6 lg:px-8 py-8 text-gray-900 border-t" style={{
    backgroundColor: 'rgb(255, 255, 255)',
    borderTopColor: 'rgba(34, 197, 94, 0.2)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-128">
      <div className="mx-auto max-w-4xl text-center" data-id="element-129">
        <div className="mb-3 font-black tracking-[2.4px] text-green-700 text-[18px]" data-id="element-130">
          🥑 BIBLIOTECA PROFESIONAL™
        </div>

        <p className="mx-auto max-w-[576px] text-xs leading-[20px] text-gray-600 m-0 mb-4" data-id="element-131">
          Recursos digitales para profesionales que quieren trabajar con más
          orden, claridad y seguridad.
        </p>

        <div className="mb-5 flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-6 text-xs text-gray-600" data-id="element-132">
          <a href="mailto:soporte@bibliotecaprofesional.com" onClick={() => trackOutbound('email')} className="no-underline text-gray-600 hover:text-green-700 transition-colors" data-id="element-133">
            📧 soporte@bibliotecaprofesional.com
          </a>

          <span className="hidden sm:block text-gray-200" data-id="element-134">|</span>

          <span className="text-gray-600" data-id="element-135">📲 @biblioteca.profesional</span>

          <span className="hidden sm:block text-gray-200" data-id="element-136">|</span>

          <a href="https://www.bibliotecaprofesional.com" target="_blank" rel="noopener noreferrer" onClick={() => trackOutbound('website')} className="no-underline text-gray-600 hover:text-green-700 transition-colors" data-id="element-137">
            🌐 www.bibliotecaprofesional.com
          </a>
        </div>

        <div className="mx-auto mb-5 h-px w-24 bg-green-700/30" data-id="element-138" />

        <div className="space-y-1" data-id="element-139">
          <p className="text-[10px] text-gray-500 m-0" data-id="element-140">
            © {new Date().getFullYear()} Biblioteca Profesional™ — Todos los
            derechos reservados.
          </p>

          <p className="text-gray-400 m-0 text-[9px]" data-id="element-141">
            Prohibida la reproducción total o parcial y la redistribución sin
            autorización expresa.
          </p>
        </div>
      </div>
    </footer>;
}